import { CompanyMonitoringAlertCategoryEnum } from '../../../../shared/models';

export const COMPANY_MONITORING_DEFAULT_SETTINGS_ALERT_CATEGORIES =
  Object.values(CompanyMonitoringAlertCategoryEnum);
